export const therapistAge = [
  { id: '20-35', name: '20-35' },
  { id: '35-50', name: '35-50' },
  { id: '50+', name: '50+' },
  { id: undefined, name: 'Не важно' },
];
